module.exports = __webpack_public_path__ + "img/icon_default.3cd6e51a.png";